import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { capitalize } from 'lodash/string';
import { translate } from 'react-i18next';
import './pastReservationCard.scss';

const PastReservationCard = ({ t, timeSlot, unit }) => {
  const duration = Object.prototype.hasOwnProperty.call(timeSlot.duration, timeSlot.type) ? timeSlot.duration[timeSlot.type] : timeSlot.duration;
  const dateFormat = 'dd D.M.YYYY';
  const timeFormat = 'H.mm';
  return (
    <div className="past-reservation-card">
      <div className="reservation-date">
        <span aria-label={`${t('common:ariaLabels.reservationDate')}${capitalize(timeSlot.timeMoment.format(dateFormat))}, ${t('atTime')} ${timeSlot.timeMoment.format('H.mm')} to ${timeSlot.timeMoment.clone().add(duration, 'minutes').format(timeFormat)}`}>{`${capitalize(timeSlot.timeMoment.format(dateFormat))} Klo ${timeSlot.timeMoment.format('H.mm')}-${timeSlot.timeMoment.clone().add(duration, 'minutes').format(timeFormat)}`}</span>
      </div>
      <div className="reservation-resource">
        <span className="resource-name">{timeSlot.resourceName}</span>
        {timeSlot.resourceType &&
        <span className="resource-name">, {timeSlot.resourceType}</span>
        }
      </div>
      <div className="reservation-unit">
        <div className="unit-name">{unit.name}</div>
        <div className="unit-address">
          {`${unit.address}, ${unit.city}`}
        </div>
      </div>
    </div>
  );
};

PastReservationCard.propTypes = {
  timeSlot: PropTypes.shape({
    timeMoment: PropTypes.instanceOf(moment).isRequired,
    unitName: PropTypes.string,
    resourceName: PropTypes.string.isRequired,
    resourceType: PropTypes.string,
    hasResponsible: PropTypes.bool,
    reservation: PropTypes.string
  }).isRequired,
  unit: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    info: PropTypes.string
  }).isRequired,
  t: PropTypes.func.isRequired
};

PastReservationCard.defaultProps = {
  unit: undefined
};

export default translate('common')(PastReservationCard);



// WEBPACK FOOTER //
// ./src/components/PastReservatioCard/index.jsx